module.exports = __webpack_public_path__ + "img/link-broken.4c47a5d9.svg";